<img  class="sentmail" type="button"  (click)="sentmail($event)" src="assets/Mail_icon.png"
mat-icon-button  >